import React, { FC } from 'react';
import styled from 'styled-components';
import { ClassNameProps } from 'components/ozone-component';
import { BodyShort01, Text03 } from 'components/styles';

const Container = styled.div`
  ${BodyShort01};
  ${Text03};
`;

interface HierarchyProps extends ClassNameProps {
  projectName?: string;
  projectPhaseName?: string;
}

export const Hierarchy: FC<HierarchyProps> = ({
  className,
  projectName,
  projectPhaseName,
}) => (
  <Container className={className}>
    {[projectName, projectPhaseName].filter(Boolean).join(' > ')}
  </Container>
);
